import script from "./SRT-Management.vue?vue&type=script&setup=true&lang=js"
export * from "./SRT-Management.vue?vue&type=script&setup=true&lang=js"

import "./SRT-Management.vue?vue&type=style&index=0&id=1e06d51f&scoped=true&lang=css"

import exportComponent from "/Users/Joe/Documents/Projects/MCR-WebFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e06d51f"]])

export default __exports__